import { useCallback, useEffect, useState } from "react";

import { errLog } from "../utils/logger";
import { getErrorMessage } from "../utils/errors";
import { useLoader } from "./useLoader";
import { ProjectDataProps } from "../Components/common/types";
import { useAlert } from "./useAlert";
import { baseURL, project } from "../config/variables";

type ProjectList = ProjectDataProps[];

export const useFetchProjects = () => {
  const [projects, setProjects] = useState<ProjectList>([]);
  const { showLoader, setShowLoader, LoaderComponent } = useLoader({fullscreen: false}); // Loader state
  const { showAlert } = useAlert(); //not global, decouple, can’t let it internally call the context anymore

  const fetchProjects = useCallback(async () => {
    setShowLoader(true);
    try {
      const response = await fetch(`${baseURL}${project}`);
      const data = await response.json();
      setProjects(data.data);
    } catch (err) {
      const errorMsg = getErrorMessage(err);
      errLog("Error during fetch: ", errorMsg);
      showAlert(true, "Error", errorMsg, false);
    } finally {
      setShowLoader(false);
    }
  }, [setShowLoader, showAlert]);

  useEffect(() => {
    fetchProjects();

    fetchProjects();
  }, [fetchProjects]);

  return { showLoader, projects, LoaderComponent, fetchProjects };
};
